import { DocumentStatus } from '../enum/documentStatus';

export class OrderDocument {
    id: number;
    status: DocumentStatus;
    type: string;
    fileName: string;
    description: string;
    orderDocumentTypeId: number;
    orderId: number;
    file: File;

    constructor() {
        this.id = 0
    }
}
